import { render, staticRenderFns } from "./ContainerFormExtend.vue?vue&type=template&id=6f32318d&"
import script from "./ContainerFormExtend.vue?vue&type=script&lang=js&"
export * from "./ContainerFormExtend.vue?vue&type=script&lang=js&"
import style0 from "./ContainerFormExtend.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports